<div class="step" [ngClass]="status" (click)="onClick()">
  {{ label }}
</div>
